import { BaseModel } from "sjs-base-model";

export default class TanBaseFormModel extends BaseModel {
    public readonly tanBase: string = "";

    constructor(data: Partial<TanBaseFormModel>) {
        super();

        this.update(data);
    }
}
